// removed by extract-text-webpack-plugin
module.exports = {"text800":"NCEKNpNUMxvtCLRZNCuUR","text700":"_3Mcs24HdJNqRmPYpJ2IICW","text600":"mK8Qf4uTZj-bcWvYyZA49","text500":"_1GvJtZuv7wfCBepCuFyTl_","text400":"QiSEqY5rDCt7OMnSKuFW7","text300":"_1rPEzURBwD_wLomthDHYZx","text200":"_3b3B3YbrwVNedNK7RJt7Qw","textParagraph":"_1e_CWEmyIKw_3cj_wYzMG-","crimp":"_2MtXY0jQITHFtGyuHiYrjV","trim":"_3qAKDhxQxD4s_LXFQPT7ri","flexCenter":"SGaAjxmq-kGKqvgf2nq9d","hideTextOverflow":"MRpsu5MrW0zbUQRwPEltB","marginPageMainContent":"H9BpAU27dZ-2S6rA-Bzyc","popconfirm":"sb7IJllxQ5tBToXkWGfoX"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/ListRoundPage/SwitchRoundFlag.scss
// module id = 237
// module chunks = 0